import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { Rule } from '../../services/capd.model';
import { Marked } from '@ts-stack/markdown';

@Component({
    selector: 'rule-preview-v2',
    templateUrl: './rule-preview.component.html'
})

/**
 * This renders a preview version of the CAPD card.
 * As it's used across several components, it gets its own modules.
 */
export class RulePreviewV2Component {
    @Input() rulePreview: Rule;
    parsedMessage = '';

    constructor(private _sanitize: DomSanitizer) {}

    /**
     * Parses the title for the card, sanitizing the HTML safely.
     *
     * @func titlePase
     * @param {string} toParse - the raw text to parse into a displayable title.
     * @returns {string} the parsed and sanitized title.
     */
    titleParse(toParse: string) {
        if (!!toParse) {
            return this._sanitize.sanitize(SecurityContext.HTML, toParse);
        }
    }

    /**
     * Parses the message of the card, both using HTML and Markdown, with proper sanitization.
     *
     * @func messageParse
     * @param {string} toParse - the raw text to parse into a displayable message.
     * @returns {string} the parsed and sanitized message.
     */
    messageParse(toParse: string) {
        if (!!toParse) {
            return this._sanitize.sanitize(SecurityContext.HTML, Marked.parse(toParse));
        }
    }
}
